import useSWR from "swr";
import { useCreateProductServiceAdminAxiosInstance } from "../../Auth/useCreateProductServiceAdminAxiosInstance.ts";

export function useLastInvoicedValueDate() {
  const { createAxiosInstance } = useCreateProductServiceAdminAxiosInstance();
  const { data, isLoading, mutate } = useSWR(
    "/bonifico-orders/invoicing/last-value-date",
    async (url) => {
      const { data } = await createAxiosInstance().get<{
        valueDateUtc?: string | null;
      }>(url);
      return data;
    },
  );
  return {
    lastValueDateUtc: data?.valueDateUtc ?? undefined,
    isLoading,
    refetch: mutate,
  };
}
